/*
 * Side nav Messages
 *
 * This contains all the text for the Side nav container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.MainNav';

export default defineMessages({
  aboutKamereo: {
    id: `${scope}.aboutKamereo`,
    defaultMessage: 'Về Kamereo',
  },
  kamereoIntroduction: {
    id: `${scope}.kamereoIntroduction`,
    defaultMessage: 'Giới thiệu Kamereo',
  },
  support: {
    id: `${scope}.support`,
    defaultMessage: 'Hỗ trợ',
  },
  languageSetting: {
    id: `${scope}.languageSetting`,
    defaultMessage: 'Cài đặt ngôn ngữ',
  },
  blog: {
    id: `${scope}.blog`,
    defaultMessage: 'Blog',
  },
  callUs: {
    id: `${scope}.callUs`,
    defaultMessage: 'Gọi chúng tôi',
  },
  changeStore: {
    id: `${scope}.changeStore`,
    defaultMessage: 'Thay đổi chi nhánh',
  },
  change: {
    id: `${scope}.change`,
    defaultMessage: 'Thay đổi',
  },
  downloadKamereoApp: {
    id: `${scope}.downloadKamereoApp`,
    defaultMessage: 'Tải ứng dụng Kamereo',
  },
  favoriteItems: {
    id: `${scope}.favoriteItems`,
    defaultMessage: 'Yêu thích',
  },
  overview: {
    id: `${scope}.overview`,
    defaultMessage: 'Báo cáo tổng quan',
  },
  orders: {
    id: `${scope}.orders`,
    defaultMessage: 'Đơn hàng',
  },
  suppliers: {
    id: `${scope}.suppliers`,
    defaultMessage: 'Nhà cung cấp',
  },
  marketPlace: {
    id: `${scope}.marketPlace`,
    defaultMessage: 'Chợ',
  },
  mart: {
    id: `${scope}.mart`,
    defaultMessage: 'Chợ',
  },
  analysis: {
    id: `${scope}.analysis`,
    defaultMessage: 'Chợ', // TODO
  },
  supplierAnalysis: {
    id: `${scope}.supplierAnalysis`,
    defaultMessage: 'Chợ', // TODO
  },
  itemAnalysis: {
    id: `${scope}.itemAnalysis`,
    defaultMessage: 'Chợ', // TODO
  },
  companyInfo: {
    id: `${scope}.companyInfo`,
    defaultMessage: 'Công ty',
  },
  scanQRorDownloadApp: {
    id: `${scope}.scanQRorDownloadApp`,
    defaultMessage: 'Quét mã QR hoặc tải App:',
  },
  quickOrderTooltip: {
    id: `${scope}.quickOrderTooltip`,
    defaultMessage: 'Đặt hàng nhanh bằng AI',
  },
  storeInfo: {
    id: `${scope}.storeInfo`,
    defaultMessage: 'Chi nhánh',
  },
  usersAndGroup: {
    id: `${scope}.usersAndGroup`,
    defaultMessage: 'Đồng nghiệp & nhóm',
  },
  groups: {
    id: `${scope}.groups`,
    defaultMessage: 'Nhóm',
  },
  usersManagement: {
    id: `${scope}.usersManagement`,
    defaultMessage: 'Đồng nghiệp',
  },
  orderHistory: {
    id: `${scope}.orderHistory`,
    defaultMessage: 'Lịch sử đơn hàng',
  },
  pendingApproval: {
    id: `${scope}.pendingApproval`,
    defaultMessage: 'Đang chờ duyệt',
  },
  pendingOrdersHistory: {
    id: `${scope}.pendingOrdersHistory`,
    defaultMessage: 'Lịch sử đơn chờ duyệt',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Tìm',
  },
  loginToSwitchStore: {
    id: `${scope}.loginToSwitchStore`,
    defaultMessage: 'Đăng nhập để chọn cửa hàng',
  },
  accountSetting: {
    id: `${scope}.accountSetting`,
    defaultMessage: 'Thiết lập tài khoản',
  },
  signOut: {
    id: `${scope}.signOut`,
    defaultMessage: 'Đăng xuất',
  },
  ownerAccount: {
    id: `${scope}.ownerAccount`,
    defaultMessage: 'Tài khoản của ',
  },
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Trang Chủ',
  },
  aboutUs: {
    id: `${scope}.aboutUs`,
    defaultMessage: 'Giới thiệu Kamereo',
  },
  careers: {
    id: `${scope}.careers`,
    defaultMessage: 'Tuyển Dụng',
  },
  paymentMethods: {
    id: `${scope}.paymentMethods`,
    defaultMessage: 'Phương thức thanh toán',
  },
  deliveryPolicy: {
    id: `${scope}.deliveryPolicy`,
    defaultMessage: 'Chính sách giao hàng',
  },
  exchangeAndReturnPolicy: {
    id: `${scope}.exchangeAndReturnPolicy`,
    defaultMessage: 'Chính sách đổi trả hàng',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'Ngôn ngữ',
  },
  downloadApp: {
    id: `${scope}.downloadApp`,
    defaultMessage: 'Tải ứng dụng',
  },
  doYouNeedHelp: {
    id: `${scope}.doYouNeedHelp`,
    defaultMessage: 'Bạn cần sự giúp đỡ?',
  },
  followUsOn: {
    id: `${scope}.followUsOn`,
    defaultMessage: 'Kết nối với chúng tôi',
  },
  signUp: {
    id: `${scope}.signUp`,
    defaultMessage: 'Đăng ký',
  },
  featureDelivery: {
    id: `${scope}.featureDelivery`,
    defaultMessage: 'Giao hàng từ 6 giờ sáng',
  },
  featureVat: {
    id: `${scope}.featureVat`,
    defaultMessage: 'VAT đầy đủ',
  },
  featureReturn: {
    id: `${scope}.featureReturn`,
    defaultMessage: 'Đổi trả trong ngày',
  },
  featureSupport: {
    id: `${scope}.featureSupport`,
    defaultMessage: 'Hỗ trợ tận tâm',
  },
  report: {
    id: `${scope}.report`,
    defaultMessage: 'Báo cáo',
  },
  overviewReport: {
    id: `${scope}.overviewReport`,
    defaultMessage: 'Báo cáo tổng quan',
  },
  itemsAnalysis: {
    id: `${scope}.itemsAnalysis`,
    defaultMessage: 'Thống kê theo sản phẩm',
  },
  userManagement: {
    id: `${scope}.userManagement`,
    defaultMessage: 'Người dùng',
  },
  groupManagement: {
    id: `${scope}.groupManagement`,
    defaultMessage: 'Nhóm',
  },
  popularSearches: {
    id: `${scope}.popularSearches`,
    defaultMessage: 'Tìm kiếm phổ biến',
  },
  businessTips: {
    id: `${scope}.businessTips`,
    defaultMessage: 'Kinh Nghiệm Kinh Doanh F&B',
  },
  foodAndLifeStyle: {
    id: `${scope}.foodAndLifeStyle`,
    defaultMessage: 'Ẩm Thực Và Đời Sống',
  },
  topPlaces: {
    id: `${scope}.topPlaces`,
    defaultMessage: 'Top Địa Điểm',
  },
  kamereoNews: {
    id: `${scope}.kamereoNews`,
    defaultMessage: 'Tin Tức Kamereo',
  },
  sharingConner: {
    id: `${scope}.sharingConner`,
    defaultMessage: 'Góc chia sẻ',
  },
  distributionLocation: {
    id: `${scope}.distributionLocation`,
    defaultMessage: 'Hệ Thống Phân Phối',
  },
  accountAndOrder: {
    id: `${scope}.accountAndOrder`,
    defaultMessage: 'Tài khoản & Đơn hàng',
  },
  recentSearches: {
    id: `${scope}.recentSearches`,
    defaultMessage: 'Bạn đã tìm',
  },
  popularSearchesTitle: {
    id: `${scope}.popularSearchesTitle`,
    defaultMessage: 'Tìm kiếm thịnh hành',
  },
  trending: {
    id: `${scope}.trending`,
    defaultMessage: 'Xu hướng',
  },
  trustedBrands: {
    id: `${scope}.trustedBrands`,
    defaultMessage: 'Thương hiệu uy tín',
  },
  introduceHP: {
    id: `${scope}.introduceHP`,
    defaultMessage: 'Giới thiệu',
  },
  suggestionHP: {
    id: `${scope}.suggestionHP`,
    defaultMessage: 'Đề xuất',
  },
  bestDeals: {
    id: `${scope}.bestDeals`,
    defaultMessage: 'Khuyến mãi',
  },
  bestPrice: {
    id: `${scope}.bestPrice`,
    defaultMessage: 'Giá tốt',
  },
  partnersHP: {
    id: `${scope}.partnersHP`,
    defaultMessage: 'Đối tác',
  },
  brandHP: {
    id: `${scope}.brandHP`,
    defaultMessage: 'Thương hiệu',
  },
  categoriesProductHP: {
    id: `${scope}.categoriesProductHP`,
    defaultMessage: 'Danh mục sản phẩm',
  },
  topGradeProduct: {
    id: `${scope}.topGradeProduct`,
    defaultMessage: 'Hàng loại 1',
  },
  newProductsHP: {
    id: `${scope}.newProductsHP`,
    defaultMessage: 'Sản phẩm mới',
  },
  quickOrderLink: {
    id: `${scope}.quickOrderLink`,
    defaultMessage: 'Đặt hàng nhanh',
  },
  referralMenuItem: {
    id: `${scope}.referralMenuItem`,
    defaultMessage: 'Giới thiệu bạn bè',
  },
  searchOverlayBack: {
    id: `${scope}.searchOverlayBack`,
    defaultMessage: 'Quay lại',
  },
  searchOverlayCart: {
    id: `${scope}.searchOverlayCart`,
    defaultMessage: 'Giỏ hàng',
  },
  searchOverlayPlaceholder: {
    id: `${scope}.searchOverlayPlaceholder`,
    defaultMessage: 'Tìm kiếm sản phẩm',
  },
});
